// extracted by mini-css-extract-plugin
export default {"uncollapsiblePanel":"EntitiesCollapse_uncollapsiblePanel__+nC0J"};